/**
 * Lightweight analytics facade for QuestionMe SPA.
 *
 * - Google Analytics 4: page views on route change + custom events
 * - Microsoft Clarity: auto-captures sessions (no manual calls needed)
 *
 * Both are no-ops when their env var is unset (local dev).
 */

// ── Google Analytics ───────────────────────────────────────────────────────────

/** Fire a GA4 page_view for SPA route changes. */
export function trackPageView(path, title) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
  });
}

/**
 * Fire a custom GA4 event.
 * @param {string} name  — event name (e.g. "chat_message", "trivia_complete")
 * @param {Record<string, string|number>} [params] — event parameters
 */
export function trackEvent(name, params = {}) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}

// ── Microsoft Clarity ──────────────────────────────────────────────────────────

/**
 * Tag the Clarity session with a custom key-value (appears in Clarity dashboard filters).
 * @param {string} key   — e.g. "voter_country", "persona_id"
 * @param {string} value — e.g. "Nigeria", "maya-chen"
 */
export function clarityTag(key, value) {
  if (typeof window.clarity !== "function") return;
  window.clarity("set", key, value);
}

/**
 * Identify the user in Clarity (links sessions to a user ID).
 * Only call after voter is authenticated.
 * @param {string} id    — voter phone or opaque ID
 * @param {string} [name] — display name (optional)
 */
export function clarityIdentify(id, name) {
  if (typeof window.clarity !== "function") return;
  window.clarity("identify", id, undefined, undefined, name);
}
